<template>
    <el-drawer v-model="drawer" title="个人信息" :before-close="handleClose" size="30%">
        <el-form :model="po.userForm" ref="poFormRef" label-width="120px" :rules="rules">
            <input type="text" id="username" class="hidden" />
            <input type="text" id="password" class="hidden" />
            <input type="text" id="mobile" class="hidden" />
            <el-form-item prop="username" label="用户名">
                <el-input v-model="po.userForm.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="realname" label="真实姓名">
                <el-input v-model="po.userForm.realname" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="level" label="角色">
                <el-select v-model="po.userForm.level">
                    <el-option v-for="item in roleList" :key="item.level" :label="item.name" :value="item.level" />
                </el-select>
            </el-form-item>

            <el-form-item prop="phone" label="手机号">
                <el-input v-model="po.userForm.phone" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="resetForm(poFormRef)">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 认</el-button>
        </template>
    </el-drawer>
</template>

<script setup>
import { defineComponent, computed, reactive, ref } from 'vue';
import request from '@/request/index.js';
import { ElMessage } from 'element-plus';
import { roleList } from '@/views/user/user.js';
const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    userinfo: {
        type: Object,
        default: () => {
            return {};
        }
    }
});
const drawer = computed({
    get: () => props.visible,
    set: () => {}
});
const po = reactive({
    userForm: props.userinfo
});
const emit = defineEmits(['close']);
const poFormRef = ref();
const roleInfo = computed(() => {
    const tempLevel = roleList.find(item => item.level === props.userinfo.level);
    return tempLevel ? tempLevel.name : '未知';
});
const handleClose = done => {
    emit('close');
};

const validateConfirmPassword = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入重复密码'));
    } else if (value !== po.userForm.password) {
        callback(new Error('密码不一致!'));
    } else {
        callback();
    }
};
const rules = reactive({
    username: [{ required: true, trigger: 'change', message: '请输入用户名' }],
    realname: [{ required: true, trigger: 'change', message: '请输入真实姓名' }],
    level: [{ required: true, trigger: 'change', message: '请选择角色' }]
});

const submitForm = () => {
    poFormRef.value.validate(async valid => {
        if (valid) {
            const requestMethod = po.userForm.id !== 0 ? 'updateUser' : 'addUser';
            const result = await request(requestMethod, po.userForm);
            if (result.status === 200) {
                ElMessage({ message: result.msg, type: 'success' });
            }
        } else {
            console.log('error submit!');
            return false;
        }
    });
};
</script>
